var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlus({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.66663 9.16669V5.83335H11.3333V9.16669H14.6666V10.8334H11.3333V14.1667H9.66663V10.8334H6.33329V9.16669H9.66663ZM10.5 18.3334C5.89746 18.3334 2.16663 14.6025 2.16663 10C2.16663 5.39752 5.89746 1.66669 10.5 1.66669C15.1025 1.66669 18.8333 5.39752 18.8333 10C18.8333 14.6025 15.1025 18.3334 10.5 18.3334ZM10.5 16.6667C12.2681 16.6667 13.9638 15.9643 15.214 14.7141C16.4642 13.4638 17.1666 11.7681 17.1666 10C17.1666 8.23191 16.4642 6.53622 15.214 5.28598C13.9638 4.03573 12.2681 3.33335 10.5 3.33335C8.73185 3.33335 7.03616 4.03573 5.78591 5.28598C4.53567 6.53622 3.83329 8.23191 3.83329 10C3.83329 11.7681 4.53567 13.4638 5.78591 14.7141C7.03616 15.9643 8.73185 16.6667 10.5 16.6667Z",
    fill: "#B45436"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlus);
export default __webpack_public_path__ + "static/media/plus.b07dc203f086a8c47c8b665af13f275d.svg";
export { ForwardRef as ReactComponent };